/**
 * Where a clinic switch lands. The Documents pages hold clinic-scoped state
 * (filters, tile, site and assignee ids in the query; an open document's id in
 * the path) that would go out against the NEW clinic on the next request, so a
 * switch from anywhere under `/documents` lands on the list with no query.
 * Other pages stay where they are.
 *
 * Called from the clinic picker's change handler, never during render: a
 * redirect returned from render runs after the remounted page's first fetch.
 *
 * Plan: docs/plans/2026-10-22-owl-waits-everywhere.md (gap 2)
 */
export function pathAfterClinicSwitch(pathname: string): string | null {
  return pathname === '/documents' || pathname.startsWith('/documents/') ? '/documents' : null;
}
